export interface IOnboardSocialChannel {
  facebook?: string
  instagram?: string
  tiktok?: string
  youtube?: string
}

export interface IOnboardSocialChannelPayload {
  type: string
  followers: string
  username: string
}

export interface OnboardDescribeYourselfMethods {
  getPayload: () => string
  resetForm: () => void
}
export interface OnboardContentNicheMethods {
  getPayload: () => Promise<string[]>
  resetForm: () => void
}

export interface OnboardSocialChannelMethods {
  getPayload: () => IOnboardSocialChannelPayload[]
  resetForm: () => void
}

export interface ICampaign {
  id?: string
  imageUrl?: string
  title: string
  bidPrice: string
  location: string
  social: {
    instagram?: string
    tiktok?: string
    facebook?: string
    youtube?: string
  }
  duration?: string
  description?: string
  sentBidPrice?: string
  note?: string
  status?: ICampaignStatus
}

export enum ICampaignStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
}
